import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { Navigation, Pagination, Scrollbar } from 'swiper';
import "swiper/swiper-bundle.min.css";
import './Home.css'
import DisplayProjects from './DisplayProjects/DisplayProjects';
import TopBanner from './TopBanner/TopBanner';

const projects = [
    {
        id: 1,
        name: 'Car Shop',
        techUsed: 'HTML',
        desc: "A niche product Full-stack website of different types of cars. ",
        livesite: 'https://assignment12-1ebce.web.app/',
        img: 'https://i.ibb.co/9tcV9bt/p1img1.png'

    },
    {
        id: 2,
        name: 'Travel',
        techUsed: 'HTML',
        desc: "A tourism-related website where clients can book their tour.",
        livesite: 'https://node-mongo-assignment11.web.app',
        img: 'https://i.ibb.co/FWsH3dr/p2img1.png'

    },
    {
        id: 3,
        name: 'MediNova Health Center',
        techUsed: 'HTML',
        desc: "A healthcare-related website where clients can book their tour. can see all the services.",
        livesite: 'https://healthcareassignment10.web.app',
        img: 'https://i.ibb.co/Mf6py5R/p3img1.png'

    },
    {
        id: 4,
        name: 'C3 Programming Center',
        techUsed: 'HTML',
        desc: "A Programming Language Learning Related website ",
        livesite: 'https://optimistic-morse-6d9a16.netlify.app/',
        img: 'https://i.ibb.co/CKh1HTV/p4img1.png'

    },
    {
        id: 5,
        name: 'Honda CBR',
        techUsed: 'HTML',
        desc: "A Programming Language Learning Related website ",
        livesite: 'https://blissful-shaw-7c2d34.netlify.app/',
        img: 'https://i.ibb.co/Fmc6QKD/p5img1.png'

    },
]



const Home = () => {
    return (
        <div >
            <TopBanner></TopBanner>
            <div className="myProjectBackground" >
                <h2 className="py-5 text-dark fw-bolder">My Projects</h2>
                <div className='swiperbackground swiper-container'>
                    <Swiper
                        breakpoints={{
                            // when window width is >= 640px
                            640: {
                                width: 640,
                                slidesPerView: 1,
                            },
                            // when window width is >= 768px
                            768: {
                                width: 768,
                                slidesPerView: 2,
                            },
                        }}
                        modules={[Navigation, Pagination, Scrollbar]}
                        spaceBetween={50}

                        navigation
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                    >
                        {
                            projects.map(project => (
                                <SwiperSlide key={project.id}>
                                    <DisplayProjects key={project.id} project={project}></DisplayProjects>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
            </div>
            <div className="container p-5">
                <h2>Contact Me</h2>
                <div className="row">
                    <div className="col">
                        <h2 className="mt-5">Get in Touch</h2>
                        <div className="d-flex align-items-center">
                            <i class="fas fa-user fa-2x"></i>
                            <div class="info ms-4">
                                <div class="head text-start" >Name</div>
                                <div class="sub-title">AKTARUZZAMAN RIDOY</div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center my-3">
                            <i class="fas fa-map-marker-alt fa-2x"></i>
                            <div class="info text-start ms-4">
                                <div class="head">Address</div>
                                <div class="sub-title">Feni Bangladesh</div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fas fa-envelope fa-2x"></i>
                            <div class="info text-start ms-4">
                                <div class="head">Address</div>
                                <div class="sub-title">Feni Bangladesh</div>
                            </div>
                        </div>
                    </div>
                    <div className="col p-5 contactmeBackground">
                        <form action="https://formsubmit.co/ridoyzzaman957@gmail.com" method="POST" className="row g-3">

                            <h3>Message Me</h3>
                            <div className="col-md-6">

                                <input type="text" name="name" required className="form-control" placeholder="Name" />
                            </div>
                            <div className="col-md-6">

                                <input type="email" name="email" required className="form-control" placeholder="Email" />
                            </div>
                            <div className="col-12">

                                <input type="text" name="subject" className="form-control" id="inputAddress" placeholder="Subject" />
                            </div>
                            <div className="col-12">

                                <textarea className="form-control" name="Message" rows="3" placeholder="Your Message"></textarea>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary">Send Message</button>
                            </div>
                        </form>
                    </div>
                </div>


            </div>
        </div >
    );
};

export default Home;